import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { AlertBubbleComponent } from './alert-bubble.component';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
    declarations: [
        AlertBubbleComponent
    ],
    entryComponents: [
        AlertBubbleComponent
    ],
    exports: [
        AlertBubbleComponent
    ],
    imports: [
        CommonModule,
        MatBadgeModule,
    ],
})
export class AlertBubbleModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            AlertBubbleComponent
        ]);
    }
}
